module.exports = __webpack_public_path__ + "img/pleasantly_v1.ca62276.png";